import { render } from "./FirstScreen.vue?vue&type=template&id=374f3628"
import script from "./FirstScreen.vue?vue&type=script&lang=js"
export * from "./FirstScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__